class QuickBuy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-quick-buy-external-el="trigger"]',
    )
    if (!trigger) return

    await window.BAO.sectionRenderer
      .fetchSingle('quick-buy-content', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        if (trigger.dataset.productProperties) {
          const properties = trigger.parentNode.querySelector(
            `[${trigger.dataset.productProperties}]`,
          ).innerHTML

          myself.querySelectorAll('form').forEach((form) => {
            form.innerHTML += properties
          })
        }

        this.els.content.element.innerHTML = myself.innerHTML

        const titleElement = this.externalEls?.title?.element

        if (titleElement) {
          titleElement.innerHTML = trigger.dataset.productTitle
        }

        window.drawers.activeDrawerKey = 'quick-buy'
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }
}

if (!customElements.get('quick-buy')) {
  customElements.define('quick-buy', QuickBuy)
}
